import React from 'react';

const OptionsBox = ({ option, type, setPrefId, checked }) => (
  <li key={option.id} className="nav-item p-3 border-bottom">
    <input
      name="options"
      type={type}
      className="d-none checkbox__input checkbox__area"
      id={`option_${option.id}`}
      onChange={(e) => setPrefId(Number(e.target.value))}
      value={option.id}
      checked={checked}
    />
    <label
      className="d-flex justify-content-between align-items-center mb-0 position-relative"
      htmlFor={`option_${option.id}`}
    >
      <span className="p-0 line-height-2 pl-3 mb-0">
        {option.option_wording}
      </span>
      <span className="checkbox__lg checkbox__noborder" />
    </label>
  </li>
);

export default OptionsBox;
